/**
 * Created by dx.yang on 2017/2/15.
 */


//新的
export const regionList = 'common/regionList';
export const initMenuRegion = 'common/initMenuRegion';
export const unifiedAjax = 'common/unifiedAjax';
export const unifiedRegion = 'common/unifiedRegion';
export const getDataApi = 'common/getDataApi';
export const getDataApiV2 = 'common/getDataApiV2';
export const RegionInfos = 'common/RegionInfos';
export const checkSnapShotPermission = 'common/checkSnapShotPermission';
export const openSnapShotService = 'common/openSnapShotService';
export const DescribeSnapshotUsageStatus = 'common/DescribeSnapshotUsageStatus';
export const DescribeSnapshotServiceStatus = 'common/DescribeSnapshotServiceStatus';


export const DescribeQuotaCount = 'common/DescribeQuotaCount'
export const DistributeKmsPermission = 'common/DistributeKmsPermission'

export const UserListForKPC = 'common/UserListForKPC'

export const CheckUserDbscRight = 'image/CheckUserDbscRight';

// 未登录
export const noLoginRegionList = 'common/noLoginRegionList';
export const checkVncPermission = 'common/checkVncPermission';
export const vncPermissionRegion = 'common/vncPermissionRegion'
export const changeSupportEbsIframe = 'common/changeSupportEbsIframe'

//保存所有全量basic机房信息，供查询是否是basic机房
export const BasicRegionList = function(regionKey) {
    var map = {　//产品确定的所有线上的basic机房
        'cn-shanghai-1': 'SHRegionOne', //上海1区
        'cn-hongkong-1': 'HKSTRegionOne', //香港1区
        'cn-beijing-1': 'BJYZRegionOne', //北京1区
        'cn-beijing-3': 'BJZJMRegionOne', //北京3区
        'cn-beijing-5': 'BJZJMVPCRegion', //北京5区(vpc)，实际是basic机房
        'cn-shanghai-7': 'SHPBSbasictestRegionOne' //测试环境的baisc
    }
    return map[regionKey];
}

//通用型主机 注：不支持本地数据盘
export const isCommonModelType = function (typeCode) {
    //通用型N1、通用型N2、通用型N3、标准型SA1、计算优化型C4、标准型S4、标准型A6、GPU虚拟型(vGN6)、推理Ⅱ型(GN6I)、IO优化型I4、大数据型D4、大数据型D6、ARM计算型FC1、性能保障型X5、计算优化型C5、性能保障型X6、GPU推理I型(GN5I)、标准型S6、性能保障型X6H、极速云盘型X6E、内存型R6、星河云服务器、网络增强型X6N、IO优化型I6、性能增强型X6S、GPU高效计算型（P5V）、性能保障型X7、GPU通用计算型GN7I、ARM计算型AC4、计算优化型C7 DPU裸金属、性能保障型X8、专属型NI6、高效型SE9、标准型S4E、轻量型E9、ARM计算型AC5、性能保障型X9a
    let commonModelTypeCodes = [40, 137, 151, 198, 347, 348, 652, 377, 326, 357, 430, 641, 401, 508, 548, 547, 597, 595, 627, 628, 647, 656, 651, 668, 650, 661, 687, 690, 710, 712 ,713, 714, 729, 731, 162006, 498, 1144, 1142, 1157];
    return _.indexOf(commonModelTypeCodes, typeCode * 1) !== -1;
}

//数据盘即支持本地ssd又支持云盘的主机类型
export const is2dataDiskType = function (typeCode) {
    //IO2、IO3、S3、X2、SN3、GPU推理计算型(P3I)、GPU通用计算型(P3)、GPU通用计算型(P4V)、GPU推理计算型(P3IN)、基础型E1、ARM计算型AC1、计算优化型C3、GPU虚拟化(vGN5)、IO优化型I4、ARM计算型AC2、IO优化型I6
    let is2dataDiskTypeCodes = [78, 110, 152, 138, 187, 101, 77, 125, 142, 303, 305, 111, 321, 357, 388, 668];
    return _.indexOf(is2dataDiskTypeCodes, typeCode * 1) !== -1;
}

//系统盘支持调整系统盘大小的主机类型
export const isAdjustSysDiskType = function (typeCode) {
    //通用型N1、IO优化型I1、IO优化型I1（联网增强）、计算优化型C1、计算优化型C1（联网增强）、IO优化型I2、IO优化型I2（联网增强）、性能保障型X2、通用型N2、通用型N3、专属2代、标准型SA1、基础型E1、ARM计算型AC1、推理Ⅱ型(GN6I)、GPU通用计算型(P3L)、标准型S3、IO优化型I3、计算优化型C3、标准网络型SN3、计算优化型C4、标准型S4、标准型A6、GPU虚拟型(vGN6)、IO优化型I4、ARM计算型AC2、GPU推理计算型(P3IN)、GPU虚拟型(vGN5)、GPU通用计算型(P3)、GPU推理计算型-P3I、GPU通用计算型(P4V)、大数据型D4、大数据型D6、ARM计算型FC1、性能保障型X5、计算优化型C5、性能保障型X6、专属3代、标准型S1、GPU推理I型(GN5I)、标准型S6、GPU专属型、性能保障型X6H、极速云盘型X6E、内存型R6、星河云服务器、网络增强型X6N、专属型6.0、IO优化型I6、性能增强型X6S、GPU高效计算型（P5V）、性能保障型X7、GPU通用计算型GN7I、ARM计算型AC4、计算优化型C7、性能保障型X8、专属型NI6、0、IO优化型I6、性能增强型X6S、GPU高效计算型（P5V）、性能保障型X7、GPU通用计算型GN7I、ARM计算型AC4、计算优化型C7、弹性裸金属、高效型SE9、标准型S4E、轻量型E9、ARM计算型AC5、性能保障型X9a
    let adjustTypeCodes = [40, 41, 45, 42, 46, 78, 79, 138, 137, 151, 143, 198, 303, 305, 326, 353, 152, 110, 111, 187, 347, 348, 652, 377, 357, 388, 142, 321, 77, 101, 125, 430, 641, 401, 508, 548, 547, 517, 298, 597, 595, 603, 627, 628, 647, 656, 651, 642, 668, 650, 661, 687, 690, 710, 712, 729, 731, 713, 714, 162006, 498, 1144, 1142, 1157];
    return _.indexOf(adjustTypeCodes, typeCode * 1) !== -1;
}

//GPU类型
export const isGpuModelType = function (typeCode) {
    //推理Ⅱ型(GN6I)、GPU通用计算型(P4V)、GPU推理计算型-P3I、GPU推理计算型(P3IN)、GPU通用计算型(P3)、GPU通用计算型(P3L)、GPU图形计算型(G1)、GPU虚拟型（vGN6）、GPU虚拟型(vGN5)、GPU推理I型(GN5I)、GPU专属型、GPU高效计算型（P5V）、GPU通用计算型GN7I
    let gpuMOdelTypesCodes = [326, 125, 101, 142, 77, 353, 126, 377, 321, 597, 603, 661, 690];
    return _.indexOf(gpuMOdelTypesCodes, typeCode * 1) !== -1;
}
//支持预迁移的本地盘机型
export const isSupportChangeInstance= function (typeCode) {
    //标准型S3、性能保障型X2、IO优化型I1、IO优化型I2、 IO优化型I3、计算优化型C1、计算优化型C3、基础型E1、IO优化型I1（联网增强）、计算优化型C1（联网增强）、IO优化型I2（联网增强）、标准网络型SN3、专属型、专属型2.0、ARM计算型AC2
    let  localModelTypesCodes= [152, 138, 41, 78, 110, 42, 111, 303, 45, 46, 79, 187, 96, 143, 388];
    return _.indexOf(localModelTypesCodes, typeCode * 1) !== -1;
}
//直连盘机型
export const isNVMeDisk = function (typeCode) {
    //IO优化型I4、大数据型D4、大数据型D6、、IO优化型I6
    const isNVMeDiskCodes= [357, 430, 641, 668];
    return _.indexOf(isNVMeDiskCodes, typeCode * 1) !== -1;
}

// 主机已上架region列表，用于在页面加载后发一些权限请求时判断缓存的region是否合法
export const regionKeyPermissionList = [
    "cn-qingyangtest-1",
    "cn-beijing-6",
    "cn-beijing-fin",
    "cn-shanghai-2",
    "cn-shanghai-fin",
    "cn-guangzhou-1",
    "cn-hongkong-2",
    "cn-taipei-1",
    "ap-singapore-1",
    "eu-east-1",
    "cn-northwest-1",
    "cn-northwest-2",
    "cn-north-vip1",
    "cn-northwest-3",
    'cn-northwest-4', 
    'cn-ningbo-1',
];
